import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Button } from '@origo/origo-ui';
import { ArrowRightIcon } from '@phosphor-icons/react';
import type { RelationPair } from '../../../types';
import styles from './RelationCard.module.css';

interface RelationCardProps {
    pair: RelationPair;
    onEdit: (id: string) => void;
}

const RelationCard: React.FC<RelationCardProps> = ({ pair, onEdit }) => {
    const { t } = useTranslation();

    return (
        <article className={styles.card}>
            {/*
               Relasjonen leses som en setning: "Viksdalen erstatter Bygstad".
               Type er verbet og sitter mellom de to planene — det er det viktigste
               signalet for en saksbehandler som skanner listen. Arrow-ikoner på
               hver side forsterker retningen uten å konkurrere med chippen.
            */}
            <div
                className={styles.relation}
                aria-label={t('relations.relationFlow', { from: pair.from.plannavn, to: pair.to.plannavn })}
            >
                <div className={styles.party}>
                    <span className={styles.partyName}>{pair.from.plannavn}</span>
                    <span className={styles.partyId}>{pair.from.planId}</span>
                </div>
                <div className={styles.connector} aria-hidden>
                    <ArrowRightIcon size={20} className={styles.connectorArrow} />
                    <Chip variant={pair.type.variant ?? 'info'}>{pair.type.label}</Chip>
                    <ArrowRightIcon size={20} className={styles.connectorArrow} />
                </div>
                <div className={styles.party}>
                    <span className={styles.partyName}>{pair.to.plannavn}</span>
                    <span className={styles.partyId}>{pair.to.planId}</span>
                </div>
            </div>
            <div className={styles.metaRow}>
                <Chip variant={pair.status.variant ?? 'default'}>{pair.status.label}</Chip>
                <span className={styles.metaDot} aria-hidden>·</span>
                <span className={styles.metaDate}>{pair.ikrafttredelsesdato.label}</span>
                <div className={styles.actions}>
                    <Button variant="secondary" size="sm" onClick={() => onEdit(pair.id)}>
                        {t('common.edit')}
                    </Button>
                </div>
            </div>
        </article>
    );
};

export default RelationCard;
